import type { ArAgingItem } from '@lombok/api-client';
import { buildCsv, csvDate, csvMoney, csvText } from '@/lib/csv';
import { statusLabel } from '@/components/StatusPill';
import { invoiceNumberLabel } from '@/features/invoices/labels';
import { agingBucketLabel, dueDaysLabel } from './labels';

/**
 * Client-side CSV export for the AR aging detail (no backend round-trip). Spanish headers:
 * Factura, Cliente, Vence, Saldo USD, Plazo, Tramo, Estado. The file follows the es-VE Excel
 * conventions of `@/lib/csv` (`;` separator, plain dd/mm/yyyy dates, decimal comma).
 *
 * `customerName` turns the account id into the name the finance team knows; when the name is
 * not available (still loading, deleted record) the id is written instead.
 */

/** Spanish column headers, in fixed order. */
export const AR_AGING_CSV_HEADERS: readonly string[] = [
  'Factura',
  'Cliente',
  'Vence',
  'Saldo USD',
  'Plazo',
  'Tramo',
  'Estado',
];

/** Build the full CSV text (header row + one row per item). */
export function toCsv(items: readonly ArAgingItem[], customerName: (customerId: string) => string | undefined = () => undefined): string {
  return buildCsv(
    AR_AGING_CSV_HEADERS,
    items.map((item) => [
      invoiceNumberLabel(item),
      csvText(customerName(item.customerId) ?? item.customerId),
      csvDate(item.dueDate),
      csvMoney(item.balanceMinorUsd),
      dueDaysLabel(item.ageDays),
      agingBucketLabel(item.bucket),
      statusLabel('invoice', item.status),
    ]),
  );
}
